import { createAction, props } from '@ngrx/store';

import { EnquiryConfig } from '@lockton-apps/shared/interfaces';

export enum UpdateEnquiryActionTypes {
  Init = '[UpdateEnquiry Page] Initialised',
  FormSubmitted = '[UpdateEnquiry Page] Form Submitted',
}

export const UpdateEnquiryActions = {
  init: createAction(UpdateEnquiryActionTypes.Init),
  formSubmitted: createAction(
    UpdateEnquiryActionTypes.FormSubmitted,
    props<{
      enquiryConfiguration: Omit<
        EnquiryConfig,
        'portalId' | 'clientId' | 'type'
      >;
    }>()
  ),
};
